<template>
  <div>
    <div class="menu-head">
      <button @click="hasHistory() ? $router.go(-1) : $router.push('/')" class="menu-head-back" />
      <subtitle>{{ project.name }}</subtitle>
    </div>

    <div class="menu-head-buttons">
      <button
        :id="name"
        @click="$emit('onIconClick', name)"
        :key="name"
        v-for="{ name, tooltip } in buttons"
        class="menu-head-icon-button"
      >
        <img :src="getImage(name)" />
        <main-tooltip :tooltipValue="tooltip" :target="name" />
      </button>

      <main-button
        id="result-ok"
        class="menu-head-calculate"
        color="secondary-fill"
        @click="$emit('onCalculateResultClick')"
        v-if="project.status == CALCULATED"
      >
        Результаты
      </main-button>

      <main-button
        id="result-warning"
        class="menu-head-calculate"
        color="warning"
        @click="$emit('onCalculateResultClick')"
        v-else-if="project.status == WARNING"
      >
        Результаты
      </main-button>

      <main-button
        id="result-error"
        class="menu-head-calculate"
        color="danger"
        @click="$emit('onСalcErrorsClick')"
        v-else-if="project.status == ERROR"
      >
        Ошибка
      </main-button>

      <main-button
        id="calculate"
        @click="isDemo ? () => {} : $emit('onCalculateClick')"
        :color="buttonColorVariant"
        :class="[
          'menu-head-calculate',
          {
            'icon-button': isCalculated || project.status == WARNING || project.status == ERROR,
          },
        ]"
      >
        {{ buttonTitle }}
        <img v-if="isCalculated || project.status == WARNING || project.status == ERROR" src="../files/reload-icon.svg" alt="" />
      </main-button>

      <main-tooltip
        v-if="isDemo"
        target="calculate"
        tooltipValue="Вы можете просматривать настройки проекта, но не можете вносить любые изменения"
      />
      <main-tooltip v-if="isCalculated" target="calculate" tooltipValue="Выполнить расчет заново" />
      <main-tooltip v-if="project.status == NOT_CALCULATED" target="calculate" tooltipValue="Выполнить расчет" />
      <main-tooltip v-if="project.status == CALCULATED" target="result-ok" tooltipValue="Результаты расчетов" />
      <main-tooltip v-if="project.status == ERROR" target="result-error" tooltipValue="Информация об ошибке" />
      <main-tooltip v-if="project.status == WARNING" target="result-warning" tooltipValue="Ограничено рассчитан" />
    </div>
  </div>
</template>

<script>
import Subtitle from "../components/ui/Subtitle.vue";
import MainButton from "../components/ui/MainButton.vue";
import MainTooltip from "./ui/MainTooltip.vue";
export default {
  data() {
    return {
      buttons: [
        { tooltip: "Настройки отчета", name: "settings" },
        { tooltip: "Дополнительные мероприятия", name: "additional-activities" },
        { tooltip: "Анализ пожарной опасности", name: "analysis" },
        { tooltip: "Настройки проекта", name: "project-menu" },
      ],
      NOT_CALCULATED: 0,
      CALCULATED: 2,
      ERROR: 3,
      WARNING: 4,
    };
  },
  components: {
    Subtitle,
    MainButton,
    MainTooltip,
  },
  props: {
    readyToCalculate: Object,
    project: Object,
  },
  computed: {
    isDemo() {
      return this.project.demo == 1;
    },

    isCalculated() {
      return (
        (this.readyToCalculate.status || this.readyToCalculate.status == 1) &&
        [2, 3, 4].includes(Number(this.project.status))
      );
    },

    buttonColorVariant() {
      if (this.isDemo) {
        return "disabled";
      }
      if (
        (this.readyToCalculate.status || this.readyToCalculate.status == 1) &&
        this.project.status == this.NOT_CALCULATED
      ) {
        return "secondary-fill";
      }
      if (!this.readyToCalculate.status || this.readyToCalculate.status == this.NOT_CALCULATED) {
        return "danger";
      }

      return "secondary-fill";
    },

    buttonTitle() {
      if (this.isCalculated || this.project.status == this.WARNING || this.project.status == this.ERROR) {
        return "";
      }
      return this.isDemo ? "Демо-режим" : "Рассчитать";
    },
  },
  methods: {
    getImage(name) {
      return require("../files/" + name + "-icon.svg");
    },

    hasHistory() {
      return window.history.length > 2;
    },
  },
};
</script>

<style scoped>
.menu-head {
  display: flex;
  align-items: center;
  gap: 8px;
}
.menu-head-back {
  padding: 0;
  min-width: 16px;
  height: 16px;
  background-color: transparent;
  border: none;
  background-image: url("../files/arrow-left-icon.svg");
  background-position: center;
  background-size: cover;
}
.menu-head-icon-button {
  background-color: transparent;
  min-width: 36px;
  height: 36px;
  border: 1px solid var(--secondary-color);
  border-radius: 4px;
}
.menu-head-buttons {
  display: flex;
  gap: 8px;
  margin-top: 16px;
}
.menu-head-calculate {
  width: 100%;
  height: 36px;
  padding: 0;
}
.icon-button {
  min-width: 64px;
  width: max-content;
}
</style>
